import React, { useState, useEffect, useRef } from 'react'
import './WebRtc.css';
import {Spinner} from "react-bootstrap";
import axios from 'axios';

function WebRtc({drone}){
    const [pc, setPear] = useState(null);
    const [websocket, setWebSocket] = useState(null);
    const videoRef = useRef(null);
    const videoContainerRef = useRef(null);
    const [isResizing, setIsResizing] = useState(false);
    const [dimensions, setDimensions] = useState({ width: 300, height: 200 });
    const [showPlayButton, setShowPlayButton] = useState(true);
    const [waitVideo, setWaitVideo] = useState(false);
    const [ice, setIce] = useState(null);

    useEffect(() => {
        axios.get('api/user/ice')
            .then(response => {
                setIce(response.data)
                console.log(response.data);
            })
            .catch((error) => {console.log(error.response)});
        return () => {

        };
    }, []);

    useEffect(() => {
        if(drone === null) {
            return;
        }
        stop();
        setShowPlayButton(true);
        setWaitVideo(false);
        
    }, [drone]);



    const handlePlayClick = () => {
        if(checkAvalible(drone)){
            createWs();
            setShowPlayButton(false);
            setWaitVideo(true);
        }
    };

    function createPeerConnection() {
        let pc = new RTCPeerConnection({
            iceServers: ice.iceServers
        });

        setPear(pc);  

        pc.addEventListener('iceconnectionstatechange', () =>
            console.log(' -> ' + pc.iceConnectionState));
    
        pc.addEventListener('icegatheringstatechange', () =>
            console.log(' -> ' + pc.iceGatheringState));
    
        pc.addEventListener('signalingstatechange', () =>
            console.log(' -> ' + pc.signalingState));

        pc.ontrack = (evt) => {
            document.getElementById('media').style.display = 'block';
            const video = videoRef.current;
            // always overrite the last stream - you may want to do something more clever in practice
            video.srcObject = evt.streams[0]; // The stream groups audio and video tracks
            video.onloadedmetadata = () => {
                video.play().then(() => {
                    setShowPlayButton(false);
                    setWaitVideo(false);
                }).catch((e) => console.warn('play() error:', e));
              };
        };

        return pc;
    }

    function createWs() {
        const wsstr = ice.ws + '?name=GS' + drone.name +'&partnerName=' + drone.name;
        const ws = new WebSocket(wsstr);
        setWebSocket(ws);
        
        ws.onopen = () => {
            //document.getElementById('start').disabled = false;
            sendRequest(ws);
            console.log('ws open');
        }
        
        ws.onmessage = async (evt) => {
            if (typeof evt.data !== 'string') {
                return;
            }
            if(evt.data == "partner connect") {
                console.log("partner connect")
            } else {
                const message = JSON.parse(evt.data);
                if (message.type == "offer") {
                    console.log('offer-sdp: ' + message.sdp);
                    await handleOffer(message, ws)
                }
            }
        }
    }

    function sendRequest(ws) {
        ws.send(JSON.stringify({
            id: "server",
            type: "request",
        }));
    }

    async function handleOffer(offer, ws) {
        const p = createPeerConnection();
        await p.setRemoteDescription(offer);
        setPear(p);
        await sendAnswer(p, ws);
    }

    async function sendAnswer(p, ws) {
        await p.setLocalDescription(await p.createAnswer());
        await waitGatheringComplete(p);
    
        const answer = p.localDescription;
        console.log('answer-sdp: '+ answer.sdp);
    
        ws.send(JSON.stringify({
            id: "server",
            type: answer.type,
            sdp: answer.sdp,
        }));
    }

    async function waitGatheringComplete(p) {
        return new Promise((resolve) => {
            if (p.iceGatheringState === 'complete') {
                resolve();
            } else {
                p.addEventListener('icegatheringstatechange', () => {
                    if (p.iceGatheringState === 'complete') {
                        resolve();
                    }
                });
            }
        });
    }

    function stop() {
        if(pc === null) {
            return;
        }
        // close transceivers
        if (pc.getTransceivers) {
            pc.getTransceivers().forEach((transceiver) => {
                if (transceiver.stop) {
                    transceiver.stop();
                }
            });
        }
    
        // close local audio/video
        pc.getSenders().forEach((sender) => {
            const track = sender.track;
            if (track !== null) {
                sender.track.stop();
            }
        });
    
        // close peer connection
        pc.close();
        setPear(null);
    }

    const startResize = (e) => {
        e.preventDefault();
        setIsResizing(true);
        window.addEventListener('mousemove', onResize);
        window.addEventListener('mouseup', stopResize);
    };

    const onResize = (e) => {
        //if (!isResizing || !videoContainerRef.current) return;
        if (!videoContainerRef.current) return;
        const rect = videoContainerRef.current.getBoundingClientRect();
        const newWidth =  rect.right - e.clientX;
        const newHeight = rect.bottom - e.clientY;
        setDimensions({
            width: Math.max(200, newWidth),
            height: Math.max(150, newHeight),
        });
    };

    const stopResize = () => {
        setIsResizing(false);
        window.removeEventListener('mousemove', onResize);
        window.removeEventListener('mouseup', stopResize);
    };

    const checkAvalible = (d) => {
        if(d == null){
            return false;
        }

        /*if(!d.isOnline) {
            return false;
        }*/

        if(d.version < 2002) {
            return false;
        }

        return true;
    }

    return(
        <>
            {!checkAvalible(drone) ? <></> : 
            <div
                id="media"
                ref={videoContainerRef}
                className="video-container"
                style={{
                display: 'block',
                width: dimensions.width,
                height: dimensions.height,
                }}
            >
                <div className="video-resize-handle" onMouseDown={startResize}></div>
                <video
                    ref={videoRef}
                    id="video"
                    autoPlay
                    playsInline
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
                {showPlayButton && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                            pointerEvents: 'none', // чтобы не блокировать resize-ручку
                        }}
                    >
                        <button
                            onClick={handlePlayClick}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '16px',
                                cursor: 'pointer',
                                pointerEvents: 'auto',
                            }}
                        >
                            ▶ Play
                        </button>
                    </div>
                )}

                {waitVideo &&(
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                            pointerEvents: 'none', // чтобы не блокировать resize-ручку
                        }}
                    >
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                )
                }
            </div>
            }
        </>
    )
}

export default WebRtc;
